module.exports = __webpack_public_path__ + "logo-left.jpg?049638b58c2a7bc5214500bb21f1209c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-left.jpg
// module id = 375
// module chunks = 0